module.exports = class PaginationRenderer {
  constructor() {}

  clearCardShells() {
    const container = document.querySelector('#main-feed');

    const cardShells = container.querySelector('#card-shells');

    if (cardShells) {
      container.removeChild(cardShells);
    }
  }

  clearPaginatedCards() {
    const container = document.querySelector('#main-feed');

    const allDeals = container.querySelector('#all-deals');
    const pagination = container.querySelector('#pull-pagination');

    if (allDeals) {
      container.removeChild(allDeals);
    }
    if (pagination) {
      container.removeChild(pagination);
    }
  }

  insertCards(cardsHtml) {
    const container = document.querySelector('#main-feed');
    const bottomAd = document.querySelector('#pull-dfp-bottom-slot');
    if (bottomAd) {
      bottomAd.insertAdjacentHTML('beforebegin', cardsHtml);
    } else {
      container.insertAdjacentHTML('beforeend', cardsHtml);
    }

    if (window.CardUI) {
      window.CardUI.init();
    }
  }

  scrollToTop() {
    const container = document.querySelector('#main-feed');

    const allDeals = container.querySelector('#all-deals');

    if (allDeals) {
      const scrollTop =
        window.scrollY ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;
      const scrollPosition = scrollTop + allDeals.getBoundingClientRect().top;
      window.scrollTo(0, scrollPosition);
    }
  }

  attachPaginationClickHandler(eventHandler) {
    const paginationElements = document.querySelectorAll('.pagination a');

    if (paginationElements && paginationElements.length) {
      paginationElements.forEach(element => {
        element.addEventListener('click', eventHandler);
      });
    }
  }
};
